import React from 'react';
import { makeStyles } from '@material-ui/core';
import ArrowDropUpIcon from '@material-ui/icons/ArrowDropUp';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import { createStyles } from '@material-ui/core/styles';
const useStyles = makeStyles(() =>
  createStyles({
    dropdown: {
      display: 'inline-grid',
      margin: '-20px 0',
    },
    show: {
      visibility: 'visible',
    },
    hide: {
      visibility: 'hidden',
    },
    arrowFontSize: {
      fontSize: '2rem',
    },
  })
);
export const ArrowDrop = React.memo((props) => {
  const classes = useStyles();
  return (
    <div
      {...props.innerProps}
      className={`${classes.dropdown} ${
        props.propertyName === props.hover || props.active
          ? classes.show
          : classes.hide
      }`}
    >
      <ArrowDropUpIcon
        viewBox="1 -9 24 24"
        className={`${classes.arrowFontSize}`}
        color={
          props.active && props.direction === 'desc' ? 'primary' : 'inherit'
        }
      />
      <ArrowDropDownIcon
        viewBox="1 9 24 24"
        className={`${classes.arrowFontSize}`}
        color={
          props.active && props.direction === 'asc' ? 'primary' : 'inherit'
        }
      />
    </div>
  );
});



// WEBPACK FOOTER //
// ./src/components/Modals/UOAModal/components/ModalArrowDrop.jsx